import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    constructor(
        private _translate: TranslateService,
        private _toast: ToastrService
    ) { }

    successi18n(message: string, title?: string): void {
        this.success(this._translate.instant(message), title ? this._translate.instant(title) : undefined)
    }
    warningi18n(message: string, title?: string): void {
        this.warning(this._translate.instant(message), title ? this._translate.instant(title) : undefined)
    }
    errori18n(message: string, title?: string): void {
        this.error(this._translate.instant(message), title ? this._translate.instant(title) : undefined)
    }
    infoi18n(message: string, title?: string): void {
        this.info(this._translate.instant(message), title ? this._translate.instant(title) : undefined)
    }

    success(message: string, title?: string): void {
        this._toast.success(message, title);
    }
    warning(message: string, title?: string): void {
        this._toast.warning(message, title);
    }
    error(message: string, title?: string): void {
        this._toast.error(message, title);
    }
    info(message: string, title?: string): void {
        this._toast.info(message, title);
    }
}
